<ion-content>
  <div class="payment-container" data-cfasync="false">
    <iframe [src]="url" frameborder="0" style="
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        border: none;
        margin: 0;
        padding: 0;
        overflow: hidden;
        z-index: 999999;
      " #myIframe id="myIframe" (load)="onLoadFunc()" class="game-iframe">Your browser doesn't support iframes</iframe>
  </div>
</ion-content>
